import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import SaveIcon from '@mui/icons-material/Save';

type SaveButtonProps = {
    onClick: () => void;
    color?: string;
};

const SaveButton: React.FC<SaveButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "primary"}
            startIcon={<SaveIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_SAVE'}/>
        </Button>
    );
};
export default SaveButton;
